import React from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { createTextMask } from "redux-form-input-masks";
import BrandingFooter from "../Footer/BrandingFooter";
import useFooter from "../../hooks/useFooter";
import classNames from "classnames";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch, useSelector } from "react-redux";
import {
  incrementCurrentSlide,
  incrementPeekSlide,
} from "../../store/slices/slides";
import { setAssessment } from "../../store/slices/assessment";

const validationSchema = Yup.object({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  dob: Yup.string()
    .matches(
      /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
      "Date of Birth should be in MM/DD/YYYY format"
    )
    .required("Date of Birth is required"),
});

function GettingStarted({ isVisible }) {
  const { user } = useAuth0();

  const dispatch = useDispatch();
  const { data: assessment } = useSelector((state) => state.assessment);
  useFooter(isVisible, <BrandingFooter />);
  console.log(assessment);
  const handleSubmit = (values) => {
    dispatch(setAssessment({ ...assessment, patient: values }));
    dispatch(incrementCurrentSlide());
    dispatch(incrementPeekSlide());
  };

  const handleChange = (e) => {
    let input = e.target.value;

    if (
      !(
        (assessment?.patient?.dob?.length === 3 && input.length === 2) ||
        (assessment?.patient?.dob?.length === 6 && input.length === 5)
      ) &&
      (input.length === 2 || input.length === 5)
    ) {
      input += "/";
    }
    return input;
  };

  // const handleBlur = (e) => {
  //   setPatientValue({
  //     ...patientValue,
  //     dateOfBirth: patientValue?.dateOfBirth,
  //   });
  // };

  const handleKeyPress = (e) => {
    if (e.key === "Backspace" || e.key === "Tab") {
      return;
    }
    const formatReg = [
      /^((0|1))/,
      /^((0|1)\d{1})/,
      /^((0|1)\d{1})\//,
      /^((0|1)\d{1})\/((0|1|2))/,
      /^((0|1)\d{1})\/((0|1|2)\d{1})/,
      /^((0|1)\d{1})\/((0|1|2)\d{1})\//,
      /^((0|1)\d{1})\/((0|1|2)\d{1})\/((1|2))/,
      /^((0|1)\d{1})\/((0|1|2)\d{1})\/((19|20))/,
      /^((0|1)\d{1})\/((0|1|2)\d{1})\/((19|20)\d{1})/,
      /^((0|1)\d{1})\/((0|1|2)\d{1})\/((19|20)\d{2})/,
    ];
    let input = e.target.value;
    if (input.length === 2 || input.length === 5) {
      input += "/";
    }
    if (input.length > 9 || !formatReg[input.length || 0].test(input + e.key)) {
      e.preventDefault();
      return;
    }
  };

  const mask = createTextMask({
    pattern: "99/99/9999",
  });

  return (
    <div className="h-full bg-how-feeling">
      <div className="block-emotti">
        <div className="block-welcome">
          <div className="">
            <h1 className="">Getting Started</h1>
            <Formik
              initialValues={{
                firstName:
                  user?.given_name || assessment?.patient?.firstName || "",
                lastName:
                  user?.family_name || assessment?.patient?.lastName || "",
                dob: assessment?.patient?.dob || "",
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ isValid, setFieldValue, values }) => (
                <Form>
                  <p className="text-lg leading-[22px]">
                    To share your results with your care team, we need the
                    following information about you:
                  </p>
                  <div className="p-2 py-5 gap-3 grid">
                    <div className="block">
                      <span className="form-label">
                        First name<span className="text-red-400">*</span>
                      </span>
                      <Field
                        type="text"
                        name="firstName"
                        className="form-control"
                        placeholder=""
                      />
                      <ErrorMessage
                        name="firstName"
                        component="div"
                        className="text-red-300"
                      />
                    </div>

                    <div className="block">
                      <span className="form-label">
                        Last name<span className="text-red-400">*</span>
                      </span>
                      <Field
                        type="text"
                        name="lastName"
                        className="form-control"
                        placeholder=""
                      />
                      <ErrorMessage
                        name="lastName"
                        component="div"
                        className="text-red-300"
                      />
                    </div>

                    <div className="block">
                      <span className="form-label">
                        Date of Birth <span className="text-red-400">*</span>
                      </span>
                      <input
                        type="text"
                        // name="dob"
                        value={values["dob"]}
                        onChange={(e) => {
                          setFieldValue("dob", handleChange(e));
                        }}
                        onKeyDown={handleKeyPress}
                        className="form-control"
                        placeholder="MM/DD/YYYY"
                        // {...mask}
                      />
                      <ErrorMessage
                        name="dob"
                        component="div"
                        className="text-red-300"
                      />
                    </div>

                    <div className="tex-center flex justify-center pt-5">
                      <div className="tex-center flex justify-end pt-5">
                        <button
                          type="submit"
                          className={classNames("btn btn-white", {
                            "cursor-default opacity-50 pointer-events-none":
                              !isValid,
                          })}
                          disabled={!isValid}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GettingStarted;
